import { c as _c } from "react/compiler-runtime";
import { useMutation } from '@apollo/client/react';
import { useDebouncedEffect } from '@react-hookz/web';
import { useToast } from '@src/components/chakra-ui/use-toast';
import { AutoResizeTextarea, AutoResizeTextareaProps } from '@src/components/sco/AutoResizeTextarea';
import { GroupRequest } from '@src/graphql-types';
import { gql } from '@src/lib/gql';
import React, { useEffect, useState } from 'react';
export type RequestTitleEditorProps = {
  groupRequest: GroupRequest;
  textAreaProps?: AutoResizeTextareaProps;
};
export const RequestTitleEditor: React.FC<RequestTitleEditorProps> = props => {
  const $ = _c(17);
  const toast = useToast();
  const [title, setTitle] = useState(props.groupRequest.title);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = gql`
    mutation ($input: UpsertGroupRequestInput!) {
      upsertGroupRequest(input: $input) {
        groupRequest {
          id
          groupRequestId
          title
        }
      }
    }
  `;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const [upsertGroupRequest] = useMutation(t0);
  let t1;
  let t2;
  if ($[1] !== props.groupRequest.title) {
    t1 = () => {
      setTitle(props.groupRequest.title);
    };
    t2 = [props.groupRequest.title];
    $[1] = props.groupRequest.title;
    $[2] = t1;
    $[3] = t2;
  } else {
    t1 = $[2];
    t2 = $[3];
  }
  useEffect(t1, t2);
  let t3;
  if ($[4] !== props.groupRequest.groupRequestId || $[5] !== props.groupRequest.title || $[6] !== title || $[7] !== toast || $[8] !== upsertGroupRequest) {
    t3 = async () => {
      if (title === props.groupRequest.title) {
        return;
      }
      await upsertGroupRequest({
        variables: {
          input: {
            groupRequestId: props.groupRequest.groupRequestId,
            title
          }
        }
      });
      toast({
        title: "Title updated",
        status: "info",
        containerStyle: {
          color: "black"
        }
      });
    };
    $[4] = props.groupRequest.groupRequestId;
    $[5] = props.groupRequest.title;
    $[6] = title;
    $[7] = toast;
    $[8] = upsertGroupRequest;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  let t4;
  if ($[10] !== props.groupRequest.title || $[11] !== title) {
    t4 = [title, props.groupRequest.title];
    $[10] = props.groupRequest.title;
    $[11] = title;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  useDebouncedEffect(t3, t4, 1000);
  let t5;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = ev => setTitle(ev.target.value);
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  let t6;
  if ($[14] !== props.textAreaProps || $[15] !== title) {
    t6 = <AutoResizeTextarea {...props.textAreaProps} color="white" fontFamily="Poppins" fontSize="xl" fontWeight="bold" minRows={1} padding={2} placeholder="Title your goal..." size="lg" value={title} onChange={t5} />;
    $[14] = props.textAreaProps;
    $[15] = title;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  return t6;
};